import React, { useState, useEffect } from 'react';
import ReactLoading from 'react-loading';
import LocalizedMessage from 'react-l10n';
import useFormState from '../../../FormStateHelper';
import { validatePostmanForm } from '../../../../selectors/defaultSelectors';
import EditPostmanFields from './EditPostmanFields';

function EditPostmanForm(props) {
    const { handleEdit, closeForm, editPostman, postmanFieldList } = props;

    let selectedPostmanOption = editPostman.InternalItemID;
    let initialFormState = {
        ID: editPostman.ID,
    };

    if(postmanFieldList[selectedPostmanOption]) {
        const parameters = postmanFieldList[selectedPostmanOption]['parameters'];

        Object.keys(parameters).forEach(parameter => {
            initialFormState = {
                ...initialFormState,
                [parameter]: editPostman[parameter]
            };
        });
    }

    const {
        formData,
        bindUpdateFormData,
        updateFormData,
        updateFormDataBulk,
        isSubmitting,
        submitForm,
        resetForm,
    } = useFormState({
        handleFormSubmission: handleEdit,
        initialFormState: initialFormState,
    });
    const [isValidated, setIsValidated] = useState(false);
    let fieldRefs = {};

    const finalFormData = {
        ...formData,
    };

    const onFormSubmit = (e) => {
        e.preventDefault();
        submitForm(finalFormData, {
            success: () => {
                closeForm();
            },
        });
    };

    const onFieldUpdate = (e) => {
        bindUpdateFormData(e);
    };

    const onUpdateFormDataBulk = (newFormData) => {
        updateFormDataBulk(newFormData);
    };

    const onFieldReset = () => {
        resetForm();
    };

    // Effects
    // --------------------
    // - Validate form
    useEffect(() => {
        setIsValidated(!validatePostmanForm(fieldRefs));
    }, [finalFormData]);

    return (
        <>
            <form className='form form-box' onSubmit={onFormSubmit}>
                <div className='vspace vspace--small'>
                    <span className='heading heading--lv5'>
                        <LocalizedMessage id={'EDIT_POSTMAN'} />: {editPostman.Title}
                    </span>
                </div>
                <div className='vspace vspace--small'>
                    <EditPostmanFields
                        defaultIsRequired={true}
                        fieldRefs={fieldRefs}
                        formData={finalFormData}
                        onFieldUpdate={onFieldUpdate}
                        onUpdateFormDataBulk={onUpdateFormDataBulk}
                        onFieldReset={onFieldReset}
                        updateFormData={updateFormData}
                        {...props}
                    />
                </div>

                <div className='row row--vcenter'>
                    <div className='col-xs-6'>
                        <button
                            type='submit'
                            className={`form__submit button ${
                                !isValidated ? 'button--disabled' : ''
                            }`}
                            disabled={!isValidated}
                        >
                            <span
                                style={{
                                    opacity: isSubmitting === true ? 0 : 1,
                                }}
                            >
                                <LocalizedMessage id={'SAVE'} />
                            </span>
                            {isSubmitting === true && (
                                <ReactLoading
                                    className='button__spinner'
                                    type='spin'
                                    color='white'
                                    height={20}
                                    width={20}
                                />
                            )}
                        </button>
                    </div>
                    <div className='col-xs-6 tx-right'>
                        <button
                            type='button'
                            className='button button--transparent'
                            onClick={() => {
                                onFieldReset();
                                closeForm();
                            }}
                        >
                            <span>
                                <LocalizedMessage id={'CANCEL'} />
                            </span>
                        </button>
                    </div>
                </div>
            </form>
        </>
    );
}

export default EditPostmanForm;
